import { useState } from "react";
import { useHealthSummary } from "./useHealthModule";
const viewModeForStatus = (status) => status === "healthy" ? "all" : "problems";
const useHealthReportViewMode = (initialCheck) => {
  const { overallStatus, hasReport } = useHealthSummary();
  const [viewMode, setViewMode] = useState(initialCheck ? "all" : void 0);
  if (viewMode === void 0 && hasReport) {
    setViewMode(viewModeForStatus(overallStatus));
  }
  return [viewMode != null ? viewMode : "problems", setViewMode];
};
export default useHealthReportViewMode;
